import '../style.scss';
import '@draft-js-plugins/inline-toolbar/lib/plugin.css';

import React from 'react';
import {
  BrowserRouter as Router, Route, Switch,
} from 'react-router-dom';

import SignIn from './profile-components/sign-in';
import SignUp from './profile-components/sign-up';
import Nav from './nav';
import Home from './home';
import Wrapper from './book-components/wrapper';
import Notebook from './notebook-components/notebook';
import SearchResults from './search-results';

function App(props) {
  return (
    <Router>
      <div>
        <Nav />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/signin" component={SignIn} />
          <Route exact path="/signup" component={SignUp} />
          <Route exact path="/notebook" component={Notebook} />
          <Route exact path="/notebook/readinglist" component={Notebook} />
          <Route exact path="/search/:query" component={SearchResults} />
          <Route exact path="/search" component={SearchResults} />
          <Route exact path="/books/:bookID/chapters" component={Wrapper} />
          <Route exact path="/books/:bookID/chapters/new" component={Wrapper} />
          <Route exact path="/contributors" component={Wrapper} />
          <Route exact path="/profile/:userID" component={Wrapper} />
          <Route exact path="/myprofile/:userID" component={Wrapper} />
          <Route exact path="/myprofile/init" component={Wrapper} />
          <Route exact path="/books/:bookID/chapters/:chapterID/pages" component={Wrapper} />
          <Route exact path="/books/:bookID/chapters/:chapterID/pages/newpage" component={Wrapper} />
          <Route exact path="/books/:bookID/chapters/:chapterID/pages/:pageID/edit" component={Wrapper} />
          <Route exact path="/books/:bookID/chapters/:chapterID/pages/:pageID" component={Wrapper} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
